// extracted by mini-css-extract-plugin
module.exports = {"container":"_3G6Ov","error":"_2m-d-","center":"kv11w","content":"mduQx","close":"nGoJN","mobile":"_1N3CD"};